import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import currentUserHasAccess from '../../../../util/widget-helper'
import { INITIAL_HESITATION_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'


const HESITATION_REASON_LIST = [
    {
        id: 'financial',
        value: 'Financial',
    },
    {
        id: 'competition_financial',
        value: 'Konkurrenz finanziell',
    },
    {
        id: 'competition_treatment_plan',
        value: 'Konkurrenz Behandlungsergebnis',
    },
    {
        id: 'bite_correction',
        value: 'Bisskorrektur',
    },
    {
        id: 'molar',
        value: 'Backenzähne',
    },
    {
        id: 'asr_not_available',
        value: 'ASR (bei uns noch nicht vefügbar)',
    },
    {
        id: 'digital_treatment_too_lose',
        value: 'Digitale Behandlung zu lose',
    },
    {
        id: 'bad_shop_experience',
        value: 'Negative Shoperfahrung',
    },
    {
        id: 'treatment_plan',
        value: 'Treatment Plan',
    },
    {
        id: 'needs_dental_treatment',
        value: 'Needs dental treatment',
    },
    {
        id: 'new_pricing',
        value: 'new pricing',
    },
    {
        id: 'other',
        value: 'Other',
    },

]

const InitialHesitationWidget = ({ readOnly, context, changeProcessContext, saveProcessContext, validationMessageList }) => {
    if (!currentUserHasAccess(INITIAL_HESITATION_WIDGET_CONTAINER)) {
        return null
    }

    return (
        <ContentBox title="Initial Hesitation">
            <Row>
                <Column size={12}>
                    <ValidationMessageList validationMessageList={validationMessageList}/>
                </Column>
            </Row>
            <Row top="M">
                <Column size={6}>
                    <LabelInput label="Reason">
                        <Select
                            name="initialHesitation"
                            object={context}
                            valueList={HESITATION_REASON_LIST}
                            addEmpty={!context.initialHesitation}
                            readOnly={readOnly}
                            onChange={(name, value) => {
                                changeProcessContext(name, value)
                                saveProcessContext()
                            }}
                        />
                    </LabelInput>
                </Column>
                <Column size={6}/>
            </Row>
        </ContentBox>
    )
}

InitialHesitationWidget.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    context: PropTypes.object.isRequired,
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
    validationMessageList: PropTypes.array.isRequired,
}

export default InitialHesitationWidget



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/InitialHesitationWidget.js